import dayjs from 'dayjs';

export const parseFlexibleDate = (value) => {
  if (!value) return null;

  if (dayjs.isDayjs(value)) {
    return value.isValid() ? value : null;
  }

  if (value instanceof Date) {
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed : null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;

    if (/^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
      const parsed = dayjs(trimmed);
      return parsed.isValid() ? parsed : null;
    }

    const dmyMatch = trimmed.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (dmyMatch) {
      const parsed = dayjs(`${dmyMatch[3]}-${dmyMatch[2]}-${dmyMatch[1]}`);
      return parsed.isValid() ? parsed : null;
    }

    const slashMatch = trimmed.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (slashMatch) {
      const parsed = dayjs(`${slashMatch[3]}-${slashMatch[2]}-${slashMatch[1]}`);
      return parsed.isValid() ? parsed : null;
    }

    const parsed = dayjs(trimmed);
    return parsed.isValid() ? parsed : null;
  }

  return null;
};

export const isExpiredDate = (value) => {
  const parsed = parseFlexibleDate(value);
  return !!parsed && parsed.endOf('day').isBefore(dayjs());
};

export const formatDisplayDate = (value) => {
  const parsed = parseFlexibleDate(value);
  return parsed ? parsed.format('DD MMM YYYY') : (value || '—');
};
